import { API_BASE_URL } from '../config';

/** Must match backend {@code WorkerRegistryProgressService.DONE_STEP_ID}. */
export const WORKER_REGISTRY_DONE_STEP_ID = '__done__';

export interface WorkerRegistryProgressPayload {
  values: Record<string, string>;
  currentStepId: string | null;
}

export async function fetchWorkerRegistryProgress(
  email: string,
  formCode: string
): Promise<WorkerRegistryProgressPayload | null> {
  if (!API_BASE_URL || !email?.trim() || !formCode?.trim()) return null;
  const params = new URLSearchParams({
    email: email.trim(),
    formCode: formCode.trim(),
  });
  const r = await fetch(`${API_BASE_URL}/api/worker-registry/progress?${params.toString()}`);
  if (!r.ok) return null;
  const data = (await r.json()) as {
    values?: Record<string, string>;
    currentStepId?: string | null;
  };
  return {
    values: data.values && typeof data.values === 'object' ? data.values : {},
    currentStepId: data.currentStepId ?? null,
  };
}

export async function upsertWorkerRegistryProgress(params: {
  email: string;
  formCode: string;
  values: Record<string, string>;
  currentStepId: string | null;
}): Promise<void> {
  if (!API_BASE_URL || !params.email?.trim()) return;
  try {
    const r = await fetch(`${API_BASE_URL}/api/worker-registry/progress`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        email: params.email.trim(),
        formCode: params.formCode.trim(),
        values: params.values,
        currentStepId: params.currentStepId,
      }),
    });
    if (!r.ok) {
      console.warn('Worker registry save failed', r.status);
    }
  } catch (e) {
    console.warn('Worker registry save failed', e);
  }
}
